module.exports = __webpack_public_path__ + "static/pic01.9323dd16.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pic01.jpg
// module id = 528
// module chunks = 35783957827783